import { Icon, Typography } from "@/components/atoms";
import { clsx } from "@/utils";

interface BookingSubHeaderProps {
  /** Left-aligned page title, e.g. "Booking Sheet" or "Booking Summary". */
  title: string;
  /** Right-aligned link label, e.g. "View Booking Summary" or "Back". */
  actionLabel: string;
  actionIcon: string;
  actionIconPosition?: "start" | "end";
  /** Extra classes for the action icon (e.g. "hidden md:block" to drop it on mobile). */
  actionIconClassName?: string;
  onAction: () => void;
  className?: string;
}

/**
 * The sub-header bar shown below the (collapsed) ClientHeader on tablet/mobile.
 * Carries the page title + the "View Booking Summary" action that opens the
 * Booking Summary slide-in panel.
 */
export const BookingSubHeader = ({
  title,
  actionLabel,
  actionIcon,
  actionIconPosition = "end",
  actionIconClassName,
  onAction,
  className,
}: BookingSubHeaderProps) => {
  return (
    <div
      className={clsx(
        "flex items-center justify-between border-b border-neutral-mid-gray bg-neutral-surface-gray px-5 py-4",
        className
      )}
    >
      <Typography variant="title">{title}</Typography>
      <button type="button" onClick={onAction} className="flex items-center gap-1.5 text-primary">
        {actionIconPosition === "start" && <Icon name={actionIcon} size="sm" className={actionIconClassName} />}
        <Typography variant="action">{actionLabel}</Typography>
        {actionIconPosition === "end" && <Icon name={actionIcon} size="sm" className={actionIconClassName} />}
      </button>
    </div>
  );
};
